import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@/hooks/useAppSelector';
import { selectLoadSecretsApi } from '@/modules/secrets/services/selectors';
import { Empty, Loadable } from '@/modules/ui';

import { useTagsList } from '../../hooks/useTagsList';
import { RemoveTagModal } from '../RemoveTagModal';
import { TagsListItem } from '../TagsListItem';
import { UpdateTagModal } from '../UpdateTagModal';

export const TagsList = () => {
    const tags = useTagsList();
    const { inProgress: showLoader } = useAppSelector(selectLoadSecretsApi);

    return (
        <>
            <UpdateTagModal />
            <RemoveTagModal />
            <Loadable showLoader={showLoader}>
                {tags.length === 0 ? (
                    <Empty text={<FormattedMessage id='tags.list.empty' />} data-testid='tags-list-empty' />
                ) : (
                    tags.map(({ name, count }) => <TagsListItem key={name} name={name} count={count} />)
                )}
            </Loadable>
        </>
    );
};
